import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { triggerNotification } from "../../component/message/Msg";
import config from "../../config";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import Swal from "sweetalert2";

const ViewChapter = () => {
  const { id, coid } = useParams();
  const { host_url, token } = config;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);

  const [chapterDetail, setChapterDetail] = useState({});
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(null);
  const [videoDescription, setVideoDescription] = useState("");
  const [assignmentDetail, setAssignmentDetail] = useState({});
  const [assignments, setAssignments] = useState([]);

  // Update handleVideoClick to accept the index of the clicked video
  const handleVideoClick = (index) => {
    setSelectedVideoIndex(index);
  };

  // Update handleClose to reset the selected video index
  const handleClose = () => {
    setSelectedVideoIndex(null);
  };

  //----------------------------------------------- select / view chapter  -------------------------------------------------R
  const getChapter = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}chapter/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            console.log("plan data:", data.data);
            setChapterDetail(data.data);
            setAssignments(data.data.assignment);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching chapter data.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id !== undefined) {
      getChapter();
    }
  }, [id]);

  //--------------show asgn ------------r

  const btnShowAssignmentHandle = async (id) => {
    setPopupLoading(true);
    try {
      await fetch(`${host_url}assignments/${id}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Successful response, update the chapters state
            // console.log(data.data);
            setAssignmentDetail(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching assignment data.");
    } finally {
      setPopupLoading(false);
    }
  };
  // ---------------------------------------------------- edit Assignment -----------------------------------------------------U
  const handleEditAssgBtn = (aid) => {
    navigate(
      `/addassignmentque/${btoa(encodeURIComponent(aid))}/chapter/${id}`
    );
  };
  // ------------------------------------------------------------------ Delete material/assignment -----------------------------------------------------D
  const handleDeleteBtn = (id, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to delete assignment. Are you sure you want to proceed?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i);
      }
    });
    //Confirm delete
    const handleDelete = (id, i) => {
      fetch(`${host_url}assignments/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", `Assignment deleted successfully`);
            const updatedData = [...assignments];
            updatedData.splice(i, 1);
            setAssignments(updatedData);
          } else if (data.status === 404) {
            triggerNotification("error", `Assignment not found`);
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification("error", `Error deleting assignment `);
        });
    };
  };

  // ------------------------------------------------- Edit / Update Plan ---------------------------------------------------- U
  const btnEditHandle = (pid) => {
    const encodedId = window.btoa(encodeURIComponent(pid));
    navigate(`/addplan/chapterid/${id}/${encodedId}`);
  };

  // ---------------------------------------------------- Delete plan ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeletePlanHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete plan. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeletePlan(deleteId, i);
      }
    });
  };
  //If confirm then delete plan
  const handleDeletePlan = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}plans/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Plan deleted successfully");
            const updatedPlans = [...chapterDetail.plans];
            updatedPlans.splice(i, 1);
            setChapterDetail((prevChapterDetail) => ({
              ...prevChapterDetail,
              plans: updatedPlans,
            }));
          } else if (data.status === 404) {
            // plan IDs Not Found
            console.error("Plan ID is not found");
            triggerNotification("error", "plan ID is not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting plan:", error);
      triggerNotification("error", "Error deleting plan");
    }
  };

  return (
    <>
      {coid ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={["View Courses", "Course Details", "Chapter Details"]}
          url={["/viewcourses", `/viewcourse/${coid}`]}
        />
      ) : (
        <Breadcrumb
          txt="Manage Chapter"
          subpath={["View Chapters", "Chapter Details"]}
          url={["/viewchapters"]}
        />
      )}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-body row g-3">
            {loading ? (
              <Spinner />
            ) : (
              <div className="col-lg-12">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1">
                  <div className=" flex">
                    {chapterDetail.icon && (
                      <img
                        className="avatar rounded-full "
                        src={chapterDetail.icon}
                        alt="Package Icon"
                      />
                    )}
                    <h5 className="ml-3 my-auto">{chapterDetail.name}</h5>
                  </div>
                </div>
                <div className="card academy-content shadow-none border">
                  <div className="p-2">
                    <div className="cursor-pointer">
                      <img
                        className="w-100 h-96 rounded"
                        src={chapterDetail.image_link}
                      ></img>
                    </div>
                  </div>
                  <div className="card-body">
                    <h5 className="mb-3 mt-2">Chapter Description</h5>
                    <div
                      className="mb-0 pt-1"
                      dangerouslySetInnerHTML={{
                        __html: chapterDetail.description,
                      }}
                    ></div>

                    {/* Details */}
                    <hr className="my-4" />
                    <h5>Details</h5>
                    <div className=" table-responsive">
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i
                                    className={`mdi mdi-check-circle-outline mdi-24px me-2`}
                                  ></i>
                                  Passing Marks :{" "}
                                  {chapterDetail.passing_marks
                                    ? chapterDetail.passing_marks + "%"
                                    : "NA"}
                                </p>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div className="me-5">
                                <p className="text-nowrap">
                                  <i
                                    className={`mdi mdi-timeline mdi-24px me-2`}
                                  ></i>
                                  Enable Control Sequence :{" "}
                                  {chapterDetail.controlled_sequence
                                    ? chapterDetail.controlled_sequence === 1
                                      ? "Yes"
                                      : "No"
                                    : "NA"}
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* plans */}
                    <hr className="my-4" />
                    <>
                      <div className="flex justify-between items-center mb-3 mt-2">
                        <h5 className="p-0 m-0 inline-block align-baseline">
                          Plans
                        </h5>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => navigate(`/addplan/chapterid/${id}`)}
                        >
                          Add Plan
                        </button>
                      </div>
                      {chapterDetail.plans &&
                        chapterDetail.plans.length > 0 && (
                          <div className=" table-responsive">
                            <table className="table table-bordered select-none">
                              <thead>
                                <tr>
                                  <th>Plan</th>
                                  <th>Duration </th>
                                  <th>Price </th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {chapterDetail.plans &&
                                  chapterDetail.plans.map((plan, i) => (
                                    <tr key={plan.cpid} className="select-none">
                                      <td className="align-top col-sm-2 ">
                                        {i + 1}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        {plan.plan_for + " " + plan.plan_unit}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        {plan.promotional_price ? (
                                          <div className="">
                                            <small>
                                              <del>{plan.plan_price}</del>
                                            </small>
                                            <p>{plan.promotional_price}</p>
                                          </div>
                                        ) : (
                                          plan.plan_price
                                        )}
                                      </td>
                                      <td className="align-top col-sm-2 ">
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-secondary m-2"
                                          onClick={() => {
                                            btnEditHandle(plan.cpid);
                                          }}
                                        >
                                          <span className="tf-icons mdi mdi-pencil"></span>
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-icon btn-danger m-2"
                                          onClick={() => {
                                            btnDeletePlanHandle(plan.cpid, i);
                                          }}
                                        >
                                          <span className="tf-icons mdi mdi-delete"></span>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                    </>

                    {/* Assignments */}
                    {assignments?.length > 0 && (
                      <h5 className="mt-4"> Assignments</h5>
                    )}
                    <div className=" mb-4">
                      {assignments && assignments.length <= 0 ? (
                        <p> Assignment not available.</p>
                      ) : (
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              {assignments &&
                                assignments.map((assignment, i) => {
                                  return (
                                    <tr key={i}>
                                      <td className="text-truncate text-heading flex justify-between">
                                        <a
                                          href={assignment?.assignment}
                                          onClick={() =>
                                            btnShowAssignmentHandle(
                                              assignment?.caid
                                            )
                                          }
                                          data-bs-toggle="modal"
                                          data-bs-target="#ViewAssignment"
                                        >
                                          <i className="mdi mdi-file mdi-20px text-success me-3"></i>
                                          {assignment?.title}
                                        </a>
                                        <div className="">
                                          <i
                                            className="menu-icon tf-icons mdi mdi mdi-checkbox-multiple-marked  col ml-4"
                                            // data-toggle="view"
                                            title="view"
                                            onClick={() =>
                                              navigate(
                                                `/studentsubmissions/${btoa(
                                                  encodeURIComponent(
                                                    assignment?.caid
                                                  )
                                                )}`
                                              )
                                            }
                                          ></i>
                                          <i
                                            className="menu-icon tf-icons mdi mdi-pencil  col ml-4"
                                            data-toggle="edit"
                                            title="Edit"
                                            onClick={() => {
                                              handleEditAssgBtn(
                                                assignment?.caid
                                              );
                                            }}
                                          ></i>
                                          <i
                                            className="menu-icon tf-icons mdi mdi mdi-delete  col ml-4"
                                            data-toggle="delete"
                                            title="Delete"
                                            onClick={() =>
                                              handleDeleteBtn(
                                                assignment?.caid,
                                                i
                                              )
                                            }
                                          ></i>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* videos */}
                  {chapterDetail.videos && chapterDetail.videos.length > 0 && (
                    <div className="mx-3">
                      <h5 className="mt-2">Content Videos</h5>
                      <div className="flex row">
                        {chapterDetail.videos.map((video, i) => (
                          <div key={i} className="col-md-3 mb-2 px-2">
                            <div className="cursor-pointer rounded w-[210px]   border-2 border-[#D3D3D3]">
                              <div className="relative">
                                <div>
                                  <div onClick={() => handleVideoClick(i)}>
                                    <img
                                      src={video?.thumbnail}
                                      alt="Video Thumbnail"
                                      className="cursor-pointer h-40 w-full rounded-t-md object-cover"
                                      // Pass the index to handleVideoClick
                                    />
                                    <span
                                      className="mdi mdi-play mdi-24px mdi-dark px-1 bg-white rounded absolute top-[50%] left-[50%] opacity-90	"
                                      style={{
                                        transform: "translate(-50%, -50%)",
                                      }}
                                    ></span>
                                  </div>

                                  {selectedVideoIndex === i && ( // Only render if the index matches the selected index
                                    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-600 bg-opacity-30 z-50">
                                      <div className="w-11/12 md:w-3/4 lg:w-1/2 xl:w-1/3">
                                        <div className="flex justify-end">
                                          <button
                                            className="text-white"
                                            onClick={handleClose}
                                          >
                                            <span className="mdi mdi-close-box-outline"></span>
                                          </button>
                                        </div>
                                        <video
                                          src={video?.video_url}
                                          type="video/mp4"
                                          playsInline
                                          controls
                                          autoPlay
                                          className="w-full h-full"
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <hr className="m-0 p-0" />
                              {(video?.thumbnail || video?.title) && (
                                <div className="flex ml-1 p-1 pt-o mt-0 items-center">
                                  {video?.thumbnail && (
                                    <span>
                                      <img
                                        src={`${video?.thumbnail}`}
                                        alt=""
                                        className="w-8 h-8  rounded-full"
                                      />
                                    </span>
                                  )}

                                  <span className="pl-2 ">{video?.title}</span>
                                </div>
                              )}
                              <div
                                className=" rounded-b bg-[#D3D3D3]"
                                data-bs-toggle="modal"
                                data-bs-target="#addNewModal"
                                onClick={() => {
                                  setVideoDescription(video?.video_description);
                                }}
                              >
                                <p className="font-semibold text-sm	 pl-2 mb-0 text-black text-center ">
                                  Description
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ----------------------------- modal assignment ----------------------------- */}
      <div
        className="modal fade"
        id="ViewAssignment"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content pt-2 pb-5 px-md-5">
            <div className="modal-header flex justify-end">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-md-0">
              {popupLoading ? (
                <Spinner />
              ) : (
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1">
                    <div className="me-1">
                      <h5 className="mb-1">{assignmentDetail.title}</h5>
                    </div>
                  </div>
                  <div className="card academy-content shadow-none ">
                    <div className="card-body">
                      <h5 className="mb-3 mt-2">Assignment Summary</h5>
                      <div
                        className="mb-0 pt-1 p-4 border rounded"
                        dangerouslySetInnerHTML={{
                          __html: assignmentDetail.summary,
                        }}
                      ></div>

                      <hr />

                      <h5 className="mb-1 mt-4">Other Details</h5>
                      <div className="mb-0 pt-1">
                        <ul className="list-unstyled my-3 py-1">
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-clock-time-four-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">Created At:</span>{" "}
                            <span>
                              {assignmentDetail.created_at &&
                                assignmentDetail.created_at
                                  .replace("T", " ")
                                  .replace(".000Z", "")}
                            </span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-timer-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Time Limit:
                            </span>{" "}
                            <span>
                              {assignmentDetail.time_limit +
                                " " +
                                assignmentDetail.time_limit_unit}
                            </span>
                          </li>

                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-numeric mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Total Points:
                            </span>{" "}
                            <span>{assignmentDetail.points}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-check-circle-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Passing Points:
                            </span>{" "}
                            <span>{assignmentDetail.passing_points}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-file-multiple-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              No Of File Allowed:
                            </span>{" "}
                            <span>{assignmentDetail.no_of_file_allowed}</span>
                          </li>
                          <li className="d-flex align-items-center mb-3">
                            <i className="mdi mdi-file-document-outline mdi-24px"></i>
                            <span className="fw-medium mx-2">
                              Maximum File Size:
                            </span>{" "}
                            <span>{assignmentDetail.max_file_size} MB</span>
                          </li>
                        </ul>
                      </div>
                      {assignmentDetail.assignments &&
                        assignmentDetail.assignments.length > 0 && (
                          <>
                            <hr />
                            <h5 className="mb-1 mt-4">Assignments</h5>
                          </>
                        )}
                      {assignmentDetail.assignments &&
                        assignmentDetail.assignments.map((assignment) => (
                          <>
                            <div
                              className="mb-0 pt-1 my-3 py-1 "
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            >
                              <div
                                onClick={() =>
                                  navigate(
                                    `/fileanddocviewer/${id}/${btoa(
                                      encodeURIComponent(assignment.assignment)
                                    )}/assignment/chapter`
                                  )
                                }
                              >
                                <i className="mdi mdi-file mdi-20px text-success me-3"></i>
                                Open Assignment
                              </div>
                            </div>
                          </>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* //----------------------------------------------- popup ----------------------------- */}
      <div
        className="modal "
        id={`addNewModal`}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-simple  modal-lg modal-add-new-cc">
          <div className="modal-content pb-2">
            <div className="modal-body p-md-0">
              <h5 className="card-header p-0 pb-3">Description</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>

              <div className="row border rounded p-2 mb-2">
                {videoDescription ? (
                  <div dangerouslySetInnerHTML={{ __html: videoDescription }} />
                ) : (
                  "No video description available"
                )}
              </div>
              <div className="d-flex justify-content-end py-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewChapter;
